<template>
  <b-overlay :show="categories === null" rounded="sm">
    <div v-if="categories !== null">
      <!-- Table Container Card -->
      <b-card class="mb-0">
        <h1 class="mb-2">لیست دسته بندی برای آگهی های فیزیکی</h1>

        <div class="m-2">
          <!-- Table Top -->
          <b-row>
            <b-col
              cols="12"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <b-button
                variant="primary"
                @click="addNewCategory = !addNewCategory"
              >
                <span class="text-nowrap">+ ساخت دسته بندی جدید</span>
              </b-button>
            </b-col>
            <!--   new Category name  -->
            <transition name="fade">
              <b-col
                v-if="addNewCategory"
                cols="12"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0 mt-1"
              >
                <b-col md="8">
                  <div class="form-label-group">
                    <b-form-input
                      class="mb-2"
                      id="name"
                      placeholder="نام دسته بندی"
                      v-model="categoryTitle"
                    />
                    <b-form-input
                      id="name"
                      placeholder="توضیحات دسته بندی"
                      v-model="categoryDescription"
                    />
                  </div>
                </b-col>
                <b-col md="2" class="mb-1">
                  <b-button @click="createPhysicalCategory" variant="success">
                    <span class="text-nowrap">ساخت</span>
                  </b-button>
                </b-col>
              </b-col>
            </transition>
          </b-row>
        </div>

        <b-table
          ref="refUserListTable"
          class="position-relative"
          :items="categories"
          responsive
          :fields="myTableColumns"
          primary-key="id"
          show-empty
          bordered
          striped
          empty-text="موردی موجود نیست!"
        >
          <!-- Column: delete -->

          <template #cell(delete)="data">
            <div
              class="cursor-pointer d-flex flex-row"
              v-b-modal.modal-delete
              @click="showModal(data.item.physicalCategoryId)"
            >
              <feather-icon size="20" icon="TrashIcon" class="text-danger" />
            </div>
          </template>

          <template #cell(edit)="data">
            <router-link
              :to="{
                name: 'apps-categories-physical-editAPhysicalCategory',
                params: { id: data.item.physicalCategoryId },
              }"
              class="cursor-pointer d-flex flex-row"
            >
              <feather-icon size="20" icon="EditIcon" />
            </router-link>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
    <b-modal
      id="modal-delete"
      centered
      ok-title="حذف"
      cancelTitle="انصراف"
      @ok="deleteCategory(deleteItem)"
    >
      <span>حذف شود؟</span>
    </b-modal>
  </b-overlay>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
  BModal,
} from "bootstrap-vue";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import PhysicalCategoriesGetAll from "@/libs/Api/Categories/PhysicalCategories/GetAllPhysicalCategories";
import PhysicalCategoriesCreate from "@/libs/Api/Categories/PhysicalCategories/CreateAPhysicalCategory";
import PhysicalCategoryDelete from "@/libs/Api/Categories/PhysicalCategories/DeleteAPhysicalCategory";
// import BlogCategoryCreateRequest from "@/libs/Api/Blog/ProductCategoryCreateRequest";
// import BlogCategoryDeleteRequest from "@/libs/Api/Blog/BlogCategoryDeleteRequest";

export default {
  name: "categories-list",
  title: "دسته بندی های فیزیکی - پنل ادمین فرادیدار",
  data() {
    return {
      categories: null,
      totalCount: null,
      addNewCategory: false,
      deleteItem: null,
      currentPage: 1,
      perPage: 10,
      myTableColumns: [
        { key: "physicalCategoryId", label: "شناسه" },
        { key: "title", label: "نام" },
        { key: "description", label: "توضیحات" },
        { key: "delete", label: "حذف" },
        { key: "edit", label: "ویرایش" },
      ],
      defaultCreateData: {
        title: null,
        seoTitle: null,
        description: null,
        seoDescription: null,
      },
    };
  },
  async created() {
    await this.getPhysicalCategories();
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    BModal,

    vSelect,
  },
  methods: {
    async getPhysicalCategories() {
      let _this = this;

      let physicalCategoriesGetAll = new PhysicalCategoriesGetAll(_this);
      await physicalCategoriesGetAll.fetch(
        function (content) {
          _this.categories = content.physicalCategories;
        },
        function (content) {
          console.log(content);
        }
      );
    },
    async createPhysicalCategory() {
      let _this = this;

      let physicalCategoriesCreate = new PhysicalCategoriesCreate(_this);
      physicalCategoriesCreate.setParams(_this.defaultCreateData);
      await physicalCategoriesCreate.fetch(
        function (content) {
          _this.$toast({
            component: ToastificationContent,
            position: "bottom-center",
            props: {
              title: `عملیات موفق`,
              icon: "CheckIcon",
              variant: "success",
              text: `دسته بندی جدید اضافه شد.`,
            },
          });
          _this.getPhysicalCategories();
        },
        function (error) {
          console.log(error);
        }
      );
    },
    async deleteCategory(param) {
      let _this = this;

      let physicalCategoryDelete = new PhysicalCategoryDelete(_this);
      physicalCategoryDelete.setId(param);
      await physicalCategoryDelete.fetch(
        function (content) {
          _this.$toast({
            component: ToastificationContent,
            position: "bottom-center",
            props: {
              title: `عملیات موفق`,
              icon: "CheckIcon",
              variant: "success",
              text: `دسته بندی جدید حذف شد.`,
            },
          });
          _this.getPhysicalCategories();
        },
        function (error) {
          console.log(error);
        }
      );
    },
    showModal(param) {
      let _this = this;
      _this.deleteItem = param;
    },
  },
  computed: {
    categoryTitle: {
      get() {
        return this.defaultCreateData.title;
      },
      set(newValue) {
        this.defaultCreateData.title = newValue;
        this.defaultCreateData.seoTitle = newValue;
      },
    },
    categoryDescription: {
      get() {
        return this.defaultCreateData.description;
      },
      set(newValue) {
        this.defaultCreateData.description = newValue;
        this.defaultCreateData.seoDescription = newValue;
      },
    },
  },
};
</script>

<style scoped></style>
